module.exports = __webpack_public_path__ + "time-de-futebol.3a300df4356d5bc1819ba4db20288ec3.jpg";